<div class="sidepanel-container">
    <div class="block-title py-2">
      <h2 *ngIf="!isOnboardingUser" appEllipsifyMe class="max-width-tooltip-400">Chat with {{userName}}</h2>
      <h2 *ngIf="isOnboardingUser">Chat with your Hiring Manager</h2>
      <div class="close-box">
        <button type="button" class="modal-close-btn close" (click)="close(false)" style="margin-left: 16px;">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
            <rect width="28" height="28" rx="6" fill="none" />
            <g transform="translate(4 4)">
              <rect width="20" height="20" fill="none" />
              <path d="M10,11.229,5.979,15.25a.789.789,0,0,1-.6.24.863.863,0,0,1-.6-.261.88.88,0,0,1,0-1.229l4-4L4.75,5.979a.8.8,0,0,1-.24-.614.875.875,0,0,1,.261-.615A.88.88,0,0,1,6,4.75l4,4.021L14.021,4.75A.869.869,0,0,1,15.25,5.979L11.229,10l4.021,4.021a.855.855,0,0,1,0,1.208.88.88,0,0,1-1.229,0Z"
                    transform="translate(-0.005 0.005)" fill="#757575" />
            </g>
          </svg>
        </button>
      </div>
    </div>
    <div class="request-activity-container onboarding-activity">
      <!-- <div class="sub-title" style="padding: 6px 16px;">
        <h2>CHAT</h2>
      </div> -->
      <div style="overflow-y: auto;" [style.max-height]="user?.archivedDate != null || activeOnboardingUser != true ? 'calc(100vh - 235px)' : 'calc(100vh - 95px)'">
        <div>
          <!-- <div class="activity-log" *ngFor="let userNote of userNotes">
            <span class="account-img d-flex">
            <img _ngcontent-mxp-c149="" alt="user-icon"
                src="https://ui-avatars.com/api/?name={{userNote?.createdByFirstName | slice:0:1}}{{userNote?.createdByLastName | slice:0:1}}&amp;rounded=true&amp;background=FFD54F&amp;font-size=0.35&amp;size=48&amp;bold=true">
            <span class="center">{{userNote.notes}}</span>
            </span>
            
            <span class="time-note float-right">{{userNote.createdDate | date :'MM/dd/yyyy hh:mm a'}}</span>
            <div class="clear"></div>
          </div>
          <div id="scrollTo"></div> -->
        
          <div class="chat-container">
            <div class="chat-history">
              <ng-container  *ngFor="let userNote of userNotes">
                <!-- <div class="date-separation mb-2">
                  <span class="separation-line-left">&nbsp;</span>
                  <span class="small-text">Today</span>
                  <span class="separation-line-right">&nbsp;</span>
                </div> -->
                <div class="agenzee mb-2"  [ngClass]="{'sender': userNote.createdBy == userId}">
                  
                  <!-- <img _ngcontent-mxp-c149="" alt="user-icon" *ngIf="userNote.createdBy != userId"
                      src="https://ui-avatars.com/api/?name={{userNote?.createdByFirstName | slice:0:1}}{{userNote?.createdByLastName | slice:0:1}}&amp;rounded=true&amp;background=FFD54F&amp;font-size=0.35&amp;size=48&amp;bold=true"> -->
        
                  <div class="msg-content">
                    {{userNote.notes}}
                  </div>
        
                  <div class="small-text">
                    <span class="mr-1">{{userNote?.createdByFirstName}} {{userNote?.createdByLastName}}</span>
                    {{userNote.createdDate | date :'MM/dd/yyyy hh:mm a'}}
                  </div>
        
                </div>
              </ng-container>
              <!-- <div *ngIf="isTyping" class="typing-indicator">Assistant is typing...</div> -->
              <div id="scrollTo"></div>
            </div>
        
           
          </div>

        </div>
        <!-- <div>
          <div class="activity-log d-flex align-items-center" *ngFor="let userNote of userNotes">
            <span class="account-img d-flex align-items-center">
              <img _ngcontent-mxp-c149="" alt="user-icon" title="{{userNote?.createdByFirstName}} {{userNote?.createdByLastName}}"
                src="https://ui-avatars.com/api/?name={{userNote?.createdByFirstName | slice:0:1}}{{userNote?.createdByLastName | slice:0:1}}&amp;rounded=true&amp;background=FFD54F&amp;font-size=0.35&amp;size=48&amp;bold=true">
              <span class="center max-width-tooltip-300" appEllipsifyMe>{{userNote.notes}}</span>
            </span>
            
            <div class="time-note text-right">{{userNote.createdDate | date :'MM/dd/yyyy hh:mm a'}}</div>
        </div>
        <div id="scrollTo"></div>
        </div> -->
      </div>
      
      <div class="data-form" [class.d-none]="user?.archivedDate != null">
        <div class="text-count">
          <textarea name="" autofocus #chatInput maxlength="500"  class="form-control" id="" [(ngModel)]="userNote.notes"
                    [disabled]="user?.archivedDate != null" (keyup.enter)="userNote.notes?.length > 0 ? onSubmit() : ''"
                    cols="30" rows="10" placeholder="Ask a question or post an update..."></textarea>
          <div class="notes-count">
            <p class="m-0">({{userNote.notes?.length > 0 ? userNote.notes?.length : 0}}/500)</p>
            <a class="commn-btn" href="javascript:void()" [class.disabled]="userNote.notes == null || userNote.notes?.length == 0" (click)="onSubmit()">Send</a>
          </div>
        </div>
      </div>
    </div>
